if($('.id--51').length){
    $('.content-inner h1').html('Hodnocení a recenze na <a href="https://www.svihej.cz/" style="font-family:noto-sans-extracondensed, sans-serif!important;">Svihej.cz</a>');
}